import "moment/locale/he";
import moment from "moment/min/moment-with-locales";

// SupplyDate formats differ between the two endpoints (future orders are
// "DD.MM.YYYY HH:mm"; the history format is unverified) — parse leniently
// and fall back to the raw string rather than blanking the row.
const SUPPLY_DATE_FORMATS = ["DD.MM.YYYY HH:mm", "DD/MM/YYYY HH:mm", moment.ISO_8601];
export const parseSupplyDate = (supplyDate) => moment(supplyDate, SUPPLY_DATE_FORMATS, true).locale("he");

export const dateLabel = (supplyDate) => {
  const m = parseSupplyDate(supplyDate);
  return m.isValid() ? m.format("dddd, D MMMM") : supplyDate?.split(" ")[0] ?? "";
};

// The payload carries a single start timestamp — no end time, so no range.
export const timeLabel = (supplyDate) => {
  const m = parseSupplyDate(supplyDate);
  return m.isValid() ? m.format("HH:mm") : supplyDate?.split(" ")[1] ?? "";
};

export const historyDateLine = (supplyDate) => {
  const m = parseSupplyDate(supplyDate);
  return m.isValid() ? `${m.format("dddd, D MMMM")}, ${m.format("HH:mm")}` : supplyDate ?? "";
};
